export type ScoreWarning = {
  position_number: number;
  original_score: string | null;
  normalized_score: string | null;
  message: string;
};

export const extractScoreWarnings = (responseData: unknown): ScoreWarning[] => {
  if (!responseData || typeof responseData !== 'object') {
    return [];
  }
  const warnings = (responseData as { score_warnings?: unknown }).score_warnings;
  return Array.isArray(warnings) ? (warnings as ScoreWarning[]) : [];
};
